/* eslint-disable react/no-danger */
import React from 'react';
import { compose } from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import Fade from '@material-ui/core/Fade';
import CircularProgress from '@material-ui/core/CircularProgress';
import OkButton from '../atoms/OkButton';
import CancelButton from '../atoms/CancelButton';

const styles = {
  customProgressAnimation: {
    animation:
      'MuiCircularProgress-keyframes-circular-rotate 0.7s linear infinite'
  },
  breakLine: {
    whiteSpace: 'pre-line'
  },
  maxWidth350: {
    maxWidth: 350
  }
};

const enhance = compose();

const Main = enhance(
  ({
    classes,
    openProgress,
    progressOkAction = null,
    progressCancelAction = null,
    loading,
    resultMessage = null
  }) => {
    return (
      <Dialog
        open={openProgress}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent className={classes.maxWidth350}>
          {!loading ? (
            <DialogContentText
              id="alert-dialog-description"
              className={classes.breakLine}
            >
              <span dangerouslySetInnerHTML={{ __html: resultMessage }} />
            </DialogContentText>
          ) : (
            <Fade in={loading} unmountOnExit>
              <CircularProgress
                disableShrink
                className={classes.customProgressAnimation}
              />
            </Fade>
          )}
        </DialogContent>
        {!loading && resultMessage && (
          <DialogActions>
            <CancelButton
              onClickAction={progressCancelAction}
              color="default"
            />
            <OkButton onClickAction={progressOkAction} color="default" />
          </DialogActions>
        )}
      </Dialog>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
